// extracted by mini-css-extract-plugin
export default {"header":"InvestigationAssetPanel_header__a8HVx","header__asset_type":"InvestigationAssetPanel_header__asset_type__UnR7m","tabs":"InvestigationAssetPanel_tabs__078I8"};